<template>
	<v-menu
		v-model="model"
		:open-delay="50"
		:close-delay="50"
		:open-on-hover="!isMobile_lg"
		scroll-strategy="close"
		:offset="16"
		location="bottom center"
		class="car-segment-tooltip">
		<template #activator="{ props }">
			<GlobalIcon class="car-segment-tooltip__icon" v-bind="props" :height="20" name="tooltip" @click.stop />
		</template>
		<div class="car-segment-tooltip__dropdown">
			<div class="car-segment-tooltip__title">
				{{ i18nService.$tDynamic('pages.panel.discount_codes.code_id.segments', segmentsMapTranslations[segment]) }}
			</div>
			<div v-if="cars" class="car-segment-tooltip__cars">
				<div v-for="(car, i) in cars" :key="i" class="car-segment-tooltip__car">
					<div class="car-segment-tooltip__car-title">{{ car.brand }} {{ car.name }}</div>
					<div v-if="car.image" class="car-segment-tooltip__car-img-container">
						<GlobalImage class="car-segment-tooltip__car-img" :src="car.image" :alt="car.fullName" />
					</div>
				</div>
			</div>
			<div v-else class="car-segment-tooltip__loader-container">
				<v-progress-circular class="car-segment-tooltip__loader" indeterminate color="var(--primary-color)"></v-progress-circular>
			</div>
		</div>
	</v-menu>
</template>

<script setup lang="ts">
const { isMobile_lg } = useWindowWidth()
const i18nService = usei18nService()

const prop = defineProps<{
	segment?: string
	segmentID?: number
}>()

const model = defineModel<boolean>()

const carsStore = useCarsStore()
// const cars = carsStore.getFilteredCars?.filter((car) => car.segment.id === prop.segmentID)?.splice(0, 4)

const cars = ref()

const getCars = async () => {
	try {
		const storeCars = carsStore.getFilteredCars?.filter((car) => car.segment.id === prop.segmentID)?.splice(0, 4)
		if (storeCars && storeCars.length > 0) {
			cars.value = storeCars
			return
		}
		const searches = [{ id: 'segment_id', values: [prop.segmentID] }]
		const { response } = await ApiService.fetchProductsByParameters(searches)
		cars.value = response?.splice(0, 4)
	} catch (err) {
		console.error(err)
	}
}

watch(
	() => model.value,
	async () => {
		console.log(model.value, cars.value)
		if (model.value && !cars.value) {
			await getCars()
		}
	},
)

// getCars()
</script>

<style lang="scss">
@import './SegmentTooltip';
</style>
